import AppConstants from '../config/app.constants';

let RouteProgressService = function ($http, $q) {

    let getRouteStops = (routeId, date, branch) => {
        return $http
            .get(AppConstants.api + `/route-progress/get-route-stops`, {
                params: {
                    routeId,
                    date,
                    branch
                }
            })
            .then((res) => {
                return res.data
            })
    }

    let getRouteOriginationCoordinates = (routeId, date) => {
        return $http
            .get(AppConstants.api + `/route-progress/get-route-origination-coordinates`, {
                params: {
                    routeId,
                    date
                }
            })
            .then((res) => {
                return res.data
            })
    }

    let getStopComments = (routeId, vaultDate, locationId) => {
        return $http
            .get(AppConstants.api + `/route-progress/get-stop-comments`, {
                params: {
                    routeId,
                    vaultDate,
                    locationId
                }
            })
            .then((res) => {
                return res.data
            })
    }

    let exportRouteStops = (routeId, date, branch) => {
        return $http
            .post(AppConstants.api + `/route-progress/export-route-stops`, { routeId, date, branch })
            .then((res) => {
                return res.data;
            })
    }

    let getEstimatedRouteMileage = (payload) => {
        return $http.post(AppConstants.api + `/on-call-routing/get-route-mileage`, payload)
            .then((res) => {
                return res.data;
            })
    }

    return {
        getRouteStops,
        getStopComments,
        exportRouteStops,
        getEstimatedRouteMileage,
        getRouteOriginationCoordinates
    }
};

RouteProgressService.$inject = ['$http', '$q']

export default RouteProgressService;



// WEBPACK FOOTER //
// ./client/app/services/route-progress.service.js